import React from 'react';

export const ModalHeader = ({ children }) => {
    return (
        <>
            <div className="modal-header">
                {children}
            </div>
        </>
    );
};
